import { success, error } from 'react-notification-system-redux';

const notification = (title, message, err) => {
	if (err) {
		return error({
			title,
			message,
			position: 'tr'
		});
	}

	return success({ title, message, position: 'tr' });
};

export default notification;



// WEBPACK FOOTER //
// ./src/utils/notification.js